import type { MediaDescriptor, ShareGrant } from "@aasaan-share/protocol";

export function canDownloadVideo(grant: ShareGrant | undefined): boolean {
  return grant?.access === "download"
    && grant.capabilities.videoDownloadV1 === true;
}

export function assertDescriptorAllowed(
  descriptor: MediaDescriptor,
  grant: ShareGrant | undefined,
): void {
  if (descriptor.kind === "video" && !canDownloadVideo(grant)) {
    throw new Error("Unexpected video descriptor for this share");
  }
}

export function visibleMediaForGrant(
  media: readonly MediaDescriptor[],
  grant: ShareGrant | undefined,
): readonly MediaDescriptor[] {
  for (const descriptor of media) assertDescriptorAllowed(descriptor, grant);
  return media;
}
